import * as questionnairesApi from "api/questionnaires";

import { useQuery } from "react-query";

import { Filters } from "types/filters";

export function useQuestionCount(
  filters: Filters,
  enabled = true
): { questionCount: number; isLoading: boolean } {
  const filtersCopy = { ...filters };
  delete filtersCopy.questionCount;
  const { data, isLoading } = useQuery(
    ["question_count", JSON.stringify(filtersCopy)],
    () => questionnairesApi.build(filters),
    { staleTime: 2 * 60 * 1000, enabled }
  );
  const availableQuestions = data?.body?.data?.questionCount || 0;
  return { questionCount: availableQuestions, isLoading };
}
